(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plant-video-player"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__plantVideoInit) return;
    window.__plantVideoInit = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-plant-video-play]');
      if (!button) return;
      var wrapper = button.closest('[data-plant-video]');
      if (!wrapper) return;
      var video = wrapper.querySelector('video');
      if (!video) return;
      document.querySelectorAll('[data-plant-video] video').forEach(function (other) {
        if (other !== video && !other.paused) other.pause();
      });
      wrapper.classList.add('is-playing');
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
      video.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
